import { instance } from "./axios";
import { authHeader } from "../../../helpers/authHeader";

const GET_DATES = "GET_DATES";
const GET_DATES_SUCCESS = "GET_DATES_SUCCESS";
const GET_DATES_FAILURE = "GET_DATES_FAILURE";

const baseURL = process.env.REACT_APP_SERVICE_URL;

const initialState = {};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_DATES_SUCCESS:
      return {
        ...state,
        ...action.payload
      };
    case GET_DATES:
    case GET_DATES_FAILURE: {
      return initialState;
    }
    default:
      return state;
  }
};

export const getDatesAPIAction = (lang = "en") => {
  const language = lang === "en" ? "ENGLISH" : "FRENCH";
  return (dispatch) => {
    dispatch({ type: GET_DATES });
    return instance
      .get(
        `${baseURL}harp/dates?language=${language}`,
        //config
        {
          headers: Object.assign(
            { "Content-Type": "application/json" },
            authHeader()
          )
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            const formattedDates = formatDateResponse(response["data"]);
            return dispatch({
              type: GET_DATES_SUCCESS,
              payload: { [lang]: formattedDates }
            });
          } else {
            return dispatch({ type: GET_DATES_FAILURE });
          }
        },
        (err) => {
          console.log("Error:", err);
          return dispatch({ type: GET_DATES_FAILURE });
        }
      );
  };
};

function formatDateResponse(datesData) {
  if (!datesData) {
    return null;
  }

  const formattedDates = {};
  for (const key in datesData) {
    if (Object.hasOwnProperty.call(datesData, key)) {
      const dateStr = datesData[key];
      if (typeof dateStr === "string") {
        // if(key === "endDate") {
        // }
        formattedDates[key] = dateStr.replace(",", "");
      } else {
        formattedDates[key] = dateStr;
      }
    }
  }
  return formattedDates;
}
